import { Banner, BREAKPOINTS, Button, COLORS, ComponentM, Size } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { selectMarket, selectTranslateWithAi, setToggleTranslateWithAi } from '../store/slices/globalConfigSlice';
import { marketList } from '../model/constants/marketContants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const TranslateContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

interface TranslateWithAIProps {
  isMedicalProduct?: boolean;
}

const TranslateWithAI = ({ isMedicalProduct }: TranslateWithAIProps) => {
  const { t } = useTranslation("articles");
  const currentMartket = useSelector(selectMarket);
  const dispatch = useDispatch();
  const translateWithAi = useSelector(selectTranslateWithAi);

  if(isMedicalProduct) 
    return<></>
    
  return (
    <Container>
      <TranslateContainer>
        <Button
          variant="tertiary"
          size={Size.Small}
          onClick={() => {
            //@ts-ignore
            posthog.capture('SUPP-TranslateContent', {
              market: currentMartket,
              language: marketList[currentMartket].language,
            });
            dispatch(setToggleTranslateWithAi(!translateWithAi));

          }}>
          {!translateWithAi ? t('Translate with AI', { ns: 'articles' }) : t('Show original', { ns: 'translation' })}
        </Button>
      </TranslateContainer>
      { translateWithAi &&
        <Banner
          type="neutral"
          linkText={t('Show original', { ns: 'translation' })}
          linkAction={() => dispatch(setToggleTranslateWithAi(false))}
          link={location.pathname}
          fullWidth={true}
        >
          {t('This content has been translated using AI and may contain inaccuracies. Please refer to the original English version for accuracy.', { ns: 'translation' })}
        </Banner>
      }
    </Container>
  );
}

export default TranslateWithAI;